import { PhoneModel } from "@/shared/models/PhoneModel";
import { TitleList } from "@/shared/models/TitleList";

export class MedicalOrderField {
  title!: string;
  value!: string[] | string;
  titleSelectValue?: TitleList[];
  scoreSelectValue?: number | null;
  listTemplate?: string;
  phoneModel?: PhoneModel;
}
